import BaseService from './base.service';

const baseService = new BaseService('mdDiagnostico', process.env.VUE_APP_BEEREADERS_API_URL);

export default {
  getDiagnostics: (params = {}) => baseService.get('getDiagnostics', { params }),

  getDiagnosticsPage: (params = {}) => baseService.get('getDiagnosticsPage', { params }),

  /**
   * Get a single diagnostic by ID
   * @param diagnosticId - Diagnostic ID
   * @param countryCode - Optional country code for variants (USA, PER)
   */
  getDiagnostic: (diagnosticId: number, countryCode?: string) => {
    const params: Record<string, number | string> = { diagnosticId };
    if (countryCode) {
      params.countryCode = countryCode;
    }
    return baseService.get('getDiagnostic', { params });
  },

  /**
   * Get diagnostic questions (lightweight, without full reading content)
   */
  getDiagnosticQuestions: (diagnosticId: number, countryCode?: string) => {
    const params: Record<string, number | string> = { diagnosticId };
    if (countryCode) {
      params.countryCode = countryCode;
    }
    return baseService.get('getDiagnosticQuestions', { params });
  },

  findFirstById: (id: number) => baseService.get('findFirstById', { params: { id } }),

  /**
   * Get pending diagnostic evaluations for a student
   * @param userId - Student user ID
   */
  findDiagnosticoPendiente: (userId: number | string) => baseService.get('findDiagnosticoPendiente', { params: { userId } }),
};
